import _extends from '@babel/runtime/helpers/extends';
import ContactUs from './shared/ContactUs.js';
export { default as ContactUs } from './shared/ContactUs.js';
import HeaderButton from './shared/HeaderButton.js';
export { default as HeaderButton } from './shared/HeaderButton.js';
import Lang from './shared/Lang.js';
export { default as Lang } from './shared/Lang.js';
import MenuItem from './shared/MenuItem.js';
export { default as MenuItem } from './shared/MenuItem.js';
import Search from './shared/Search.js';
export { default as Search } from './shared/Search.js';
import SearchField from './shared/SearchField.js';
export { default as SearchField } from './shared/SearchField.js';
import SignIn from './shared/SignIn.js';
export { default as SignIn } from './shared/SignIn.js';
import { CONTENT_TYPE, LANG_VARIANT, MOBILE_MENU_VARIANT, SIGN_IN_VARIANT, TAB_VARIANT } from './constants.js';
export { CONTENT_TYPE, LANG_VARIANT, MOBILE_MENU_VARIANT, SIGN_IN_VARIANT, TAB_VARIANT } from './constants.js';
import MainNavItem from './MainNavItem.js';
export { default as MainNavItem } from './MainNavItem.js';
import SideNav$1 from './SideNav.js';
import SideNavSection from './SideNavSection.js';
export { default as SideNavSection } from './SideNavSection.js';
import SubNavDropdown from './SubNavDropdown.js';
export { default as SubNavDropdown } from './SubNavDropdown.js';
import SubNavItem from './SubNavItem.js';
export { default as SubNavItem } from './SubNavItem.js';

var SideNav = _extends(SideNav$1, {
  ContactUs: ContactUs,
  CONTENT_TYPE: CONTENT_TYPE,
  LANG_VARIANT: LANG_VARIANT,
  MOBILE_MENU_VARIANT: MOBILE_MENU_VARIANT,
  SIGN_IN_VARIANT: SIGN_IN_VARIANT,
  TAB_VARIANT: TAB_VARIANT,
  HeaderButton: HeaderButton,
  Lang: Lang,
  MenuItem: MenuItem,
  Search: Search,
  SearchField: SearchField,
  SignIn: SignIn,
  SubNavItem: SubNavItem,
  Dropdown: SubNavDropdown,
  NavItem: MainNavItem,
  Section: SideNavSection
});

export { SideNav as default };
